<template>
  <div>
    <ConfirmationPopup
      :show="sourceLinkConfirmationShow"
      title="Warning"
      :text="sourcePopupText"
      :buttonCancel="sourceLinkConfirmationBtnCancel"
      :buttonAction="sourceLinkConfirmationBtnAction"
    ></ConfirmationPopup>
  </div>
</template>

<script>
import { hasSourceLinkPopupAccess } from "@/services/user/user.service";

export default {
  name: "LeaveAppPopup",
  components: {
    ConfirmationPopup: () => import("@/components/common/ConfirmationPopup"),
  },
  props: {
    show: {
      type: String,
    },
    link: {
      type: String,
    },
  },
  data: () => ({
    sourceLinkConfirmationShow: false,
    sourcePopupText:
      "You are leaving the Seerist platform, the link you are clicking is outside of the control of Seerist Inc.",
  }),
  computed: {
    isSourcePopupFeatureUnlocked() {
      return hasSourceLinkPopupAccess();
    },
    sourceLinkConfirmationBtnAction() {
      return {
        text: "Continue to website",
        onClickFnc: () => {
          this.setConfirmationShow(false);
          this.goToUrl(this.sourceLink);
        },
      };
    },
    sourceLinkConfirmationBtnCancel() {
      return {
        text: "Cancel",
        onClickFnc: () => {
          this.setConfirmationShow(false);
        },
      };
    },
  },
  methods: {
    openSource(url) {
      if (this.isSourcePopupFeatureUnlocked) {
        this.sourcePopupText = `<p>You are leaving the Seerist platform, the link you are clicking is outside of the control of Seerist Inc.</p><p>${url}</p>`;
        this.setConfirmationShow(true);
        this.sourceLink = url;
      } else {
        this.goToUrl(url);
      }
    },
    setConfirmationShow(value) {
      this.sourceLinkConfirmationShow = value;
    },
    goToUrl(url) {
      window.open(url, "_blank");
    },
  },
  watch: {
    show: {
      handler() {
        if (this.show && this.link) {
          this.openSource(this.link);
        }
      },
    },
  },
};
</script>
